<template>
<div class="messages" ref="messages" v-visibility-change="visibilityChange">
  <message-item v-for="message in messages" :key="message.id"
    :message="message"
    :from="getFrom(message)"
    :messageType="messageType(message)" />
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MessageItem from '@/components/messaging/message-item'
import VueVisibility from 'vue-visibility-change'

export default {
  components: { MessageItem },
  props: {
    conversation: {
      type: Object,
      required: true
    },
    messages: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    messages () {
      const div = this.$refs.messages
      process.nextTick(() => {
        div.scrollTop = div.scrollHeight
      })
      if (this.messages.length > 0 &&
          ((VueVisibility.isSupported() && !VueVisibility.hidden()) ||
          document.hasFocus())) {
        this.setReadMessage(this.messages[this.messages.length - 1])
      }
    }
  },
  computed: {
    ...mapState('users', [
      'user'
    ])
  },
  methods: {
    ...mapActions('conversations', [
      'setReadMessage'
    ]),
    getFrom (message) {
      return {
        id: message.senderId,
        firstName: message.senderFirstName,
        lastName: message.senderLastName,
        profilePictureUrl: message.senderImageUrl
      }
    },
    messageType (message) {
      return this.user.id === message.senderId ? 'sent' : 'received'
    },
    visibilityChange (event, hidden) {
      if (!hidden) {
        if (this.messages.length > 0) {
          this.setReadMessage(this.messages[this.messages.length - 1])
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.messages {
  background: white;
  flex-grow: 1;
  overflow-y: scroll;
  margin-bottom: 82px;
}
</style>



// WEBPACK FOOTER //
// src/components/messaging/messages-view.vue